import { useEffect } from "react";
import CloseIcon from "assets/icons/close-grey.svg?react";
import { PageInfo } from "hooks/useBackToGame";
import { useNavigate } from "react-router-dom";

import "./styles.sass";
import useTranslate from "hooks/useTranslate";
import { useGTM } from "hooks/useGTM";

interface IBackToGameProps {
  data: Required<PageInfo>;
  dismiss: () => void;
}

export const BackToGame = ({ data, dismiss }: IBackToGameProps) => {
  const navigate = useNavigate();
  const t = useTranslate();
  const GTM = useGTM();

  useEffect(() => {
    GTM.showBackToGameBookmark(data.title, data.gameId);
  }, [GTM, data]);

  return (
    <div className="BackToGame-container">
      <div className="BackToGame-card">
        <button
          type="button"
          className="BackToGame-info"
          onClick={() => {
            GTM.clickBackToGameBookmark(data.title, data.gameId);
            navigate(data.link);
            dismiss();
          }}
        >
          <div className="BackToGame-cover">
            <img src={data.cover} alt={data.title} />
          </div>
          <div className="BackToGame-game">
            <div className="BackToGame-top-hint">
              {t("popup.backToGame.youPlayed")}
            </div>
            <div className="BackToGame-title">{data.title}</div>
            <div className="BackToGame-bottom-hint">
              {t("popup.backToGame.clickToBackToGame")}
            </div>
          </div>
        </button>
        <button
          type="button"
          className="BackToGame-close"
          onClick={() => {
            GTM.closeBackToGameBookmark(data.title, data.gameId);
            dismiss();
          }}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};
